import { t } from 'i18next';
import useUserQuery from '../../../components/api/queries/useUserQuery';

const TERM_LIST = [
  { id: 1, title: t('Agreement.useDuringOneYear'), category: 'refund_exchange_policy' },
  { id: 2, title: t('Agreement.checkOrder'), category: 'terms_of_service' },
  { id: 3, title: t('Agreement.protectPrivacy'), category: 'privacy_policy' }
];

const BettieAgreementSection = () => {
  const user = useUserQuery();

  return (
    <div className="flex flex-col gap-[16px]">
      {TERM_LIST.map((term) => (
        <div key={term.id} className="flex items-center justify-between">
          <p className="text-[13px] leading-[16px] text-text-main-lv3">{term.title}</p>
          <a
            href={`/fanhearts?path=terms&category=${term.category}&locale=${user?.locale}`}
            className="text-[13px] leading-[16px] text-text-main-lv3 underline"
          >
            {t('Agreement.detail')}
          </a>
        </div>
      ))}
    </div>
  );
};

export default BettieAgreementSection;

